import * as React from 'react'
import { ActionIcon } from '@mantine/core'

// 社区行政村减灾能力
const SvgComponent = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 26"
    class="design-iconfont"
    width={width}
    height={height}
  >
    <defs>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="98.993048%"
        id="rt47orz30__lgf68d586b"
      >
        <stop stop-color="#4AB6F5" offset="0%" />
        <stop stop-color="#227BF9" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="50%"
        y1="0%"
        x2="50%"
        y2="100%"
        id="rt47orz30__kjotcusrna"
      >
        <stop stop-color="#7DCFFF" offset="0%" />
        <stop stop-color="#60A2FE" offset="100%" />
      </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        d="M10.7586207,1 C13.4527454,1 15.8915589,2.09863836 17.6570109,3.87410315 C19.424504,5.65162062 20.5172414,8.10737032 20.5172414,10.8196383 C20.5172414,13.2054308 19.0111003,16.1209359 17.1884092,18.6927443 C14.8576982,21.9813662 11.9231088,25 10.7586207,25 C9.59413261,25 6.6595432,21.9813662 4.3288322,18.6927443 C2.50614105,16.1209359 1,13.2054308 1,10.8196383 C1,8.10737032 2.0927374,5.65162062 3.8602305,3.87410315 C5.62568251,2.09863836 8.06449597,1 10.7586207,1 Z"
        stroke="url(#rt47orz30__kjotcusrna)"
        stroke-width="2"
        fill="url(#rt47orz30__lgf68d586b)"
      />
      <path
        d="M10.3242827,3.42986099 L10.7586207,3.42986099 L9.52094952,0.131967009 L8.28199712,3.42986099 L8.7188976,3.42986099 L8.28199712,4.58937694 L8.7188976,4.58937694 L8.28199712,5.75017412 L9.276234,5.75017412 L9.276234,8.55863707 L0.257634253,8.55863707 L0.257634253,9.53493668 L10.5139052,9.53493668 L10.5139052,8.55863707 L9.76566504,8.55863707 L9.76566504,5.75017412 L10.7586207,5.75017412 L10.3242827,4.58937694 L10.7586207,4.58937694 L10.3242827,3.42986099 Z M0.788064754,8.25498482 L7.37232162,8.25498482 L7.37232162,4.34978635 L7.94503282,4.34978635 C8.13465531,4.34978635 8.23202903,4.12172686 8.09878079,3.98463492 L4.25892521,0.0755927525 C4.21151958,0.026905895 4.14745793,0 4.07955257,0 C4.01164722,0 3.94758556,0.026905895 3.90017994,0.0755927525 L0.0616055901,3.98463492 C-0.0716426517,4.1191644 0.0257310634,4.34978635 0.215353561,4.34978635 L0.788064754,4.34978635 L0.788064754,8.25498482 Z M4.2781437,4.34978635 L5.60037625,4.34978635 L5.60037625,5.67201891 L4.2781437,5.67201891 L4.2781437,4.34978635 L4.2781437,4.34978635 Z M4.2781437,6.0781698 L5.60037625,6.0781698 L5.60037625,7.40040235 L4.2781437,7.40040235 L4.2781437,6.0781698 Z M2.09364128,4.34978635 L3.41587383,4.34978635 L3.41587383,5.67201891 L2.09364128,5.67201891 L2.09364128,4.34978635 Z M2.09364128,6.0781698 L3.41587383,6.0781698 L3.41587383,7.40040235 L2.09364128,7.40040235 L2.09364128,6.0781698 Z"
        transform="translate(5.428253 5.953664)"
        fill="#E2F2FF"
        fill-rule="nonzero"
      />
    </g>
  </svg>
)

const Icon = (props) => {
  const {
    fill = '#0152D9',
    variant = 'transparent',
    size = 20,
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <SvgComponent width={width} height={height} color={fill} />
    </ActionIcon>
  )
}

export default Icon
